import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  success: false,
  transactions: [],
  summary: null,
};

export const finance = (state = initialState, action) => {
  switch (action.type) {
    case 'FINANCE_REQUEST':
      return { ...state, loading: true, error: null };

    case 'FINANCE_SUCCESS':
      return { ...state, loading: false, success: true };

    case 'FINANCE_SUMMARY_SUCCESS':
      return { ...state, loading: false, summary: action.payload };

    case 'FINANCE_FAIL':
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
